'use client';

export interface TeamProofTextProps {
  text?: string;
}

export function TeamProofText({ text }: TeamProofTextProps) {
  return (
    <div className="bg-navy py-12 tablet:py-[96px]">
      <div className="mx-auto w-full max-w-[1490px] px-4">
        <p className="text-left font-heldane font-normal leading-[120%] text-at mobile-only:text-[36px] tablet:text-center tablet:text-serviceProof">
          {text}
        </p>
      </div>
    </div>
  );
}
